import React from "react";
import styles from "./dummyDashboard.module.css";
import avatar from "utils/assets/Profile_Photo.svg";

const CARDS = [
  { id: 1, name: "Jennifer Adamson", oxygen: 90, color: "orange" },
  { id: 2, name: "Jennifer Adamson", oxygen: 98, color: "teal" },
  { id: 3, name: "Jennifer Adamson", oxygen: 98, color: "teal" },
  { id: 4, name: "Jennifer Adamson", oxygen: 88, color: "red" },
  { id: 5, name: "Jennifer Adamson", oxygen: 98, color: "teal" },
  { id: 6, name: "Jennifer Adamson", oxygen: 90, color: "orange" },
];

function StatItem({ label, value, unit, sub }) {
  return (
    <div className={styles.statItem}>
      <span className={styles.statLabel}>{label}</span>
      <div className={styles.statValueRow}>
        <span className={styles.statValue}>{value}</span>
        {unit ? <span className={styles.statUnit}>{unit}</span> : null}
      </div>
      {sub ? <span className={styles.statSub}>{sub}</span> : null}
    </div>
  );
}

function BottomItem({ label, value }) {
  return (
    <div className={styles.bottomItem}>
      <div className={styles.bottomLabel}>{label}</div>
      <div className={styles.bottomValue}>{value}</div>
    </div>
  );
}

function Card({ name, oxygen, color }) {
  return (
    <div className={styles.card}>
      
      <div className={styles.cardHeader}>
        <img className={styles.avatar} src={avatar} alt="Profile" />
        <div className={styles.name}>{name}</div>
      </div>
      <div className={`${styles.cardAccent} ${styles[color]}`} />
      <div className={styles.cardBody}>
        <div className={styles.colLeft}>
          <div className={styles.sectionTitle}>Oxygen</div>
          <div className={styles.oxygenRow}>
            <span className={styles.oxygenValue} data-color={color}>
              {oxygen}
            </span>
            <span className={styles.percent}>%</span>
          </div>
          <div className={styles.sectionTitle}>Pulse Rate</div>
          <div className={styles.heartRateRow}>
            <span className={styles.heartValue}>77</span>
            <span className={styles.heartUnit}>bpm</span>
          </div>
        </div>
        <div className={styles.colRight}>
          <StatItem label="SpO₂ Variability" value="45" unit="mL/s" />
          <StatItem label="Perfusion Index" value="11" unit="%" />
          <StatItem label="HRV" value="55" unit="ms" />
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.cardFooter}>
        <BottomItem label="Humidity" value="48%" />
        <BottomItem label="Altitude" value="512 feet" />
        <BottomItem label="Temperature" value="60 °F" />
        <BottomItem
          label="Air Quality Index"
          value={
            <>
              <span>75 </span>
              <span className={styles.moderate}>moderate</span>
            </>
          }
        />
      </div>
    </div>
  );
}

export default function DummyDashboard() {
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
      
        <button className={styles.closeBtn} aria-label="close">
          ×
        </button>
      </div>
      <div className={styles.grid}>
        {CARDS.map((c) => (
          <Card key={c.id} name={c.name} oxygen={c.oxygen} color={c.color} />
        ))}
      </div>
    </div>
  );
}



